<template>
    <div class="courseList">
        <div class="paddingH16 clearfix" :class="layout">
            <div class="item" v-for="dataItem in dataList"
                 :key="dataItem.id" @click="viewItem(dataItem)">

                <!-- 水平3卡片布局 -->
                <div class="inner" v-if="layout === 'horizontal3CardLayout'">
                    <div class="imageArea marginB8">
                        <img class="cover fullSpace" :src="dataItem.coverImg"/>
                        <div class="descArea f12 white">
                            共{{dataItem.applicantCount}}人学
                        </div>
                    </div>
                    <div class="titleArea font16r color333 bold">{{dataItem.title}}</div>
                </div>

                <!-- 纵向图文布局 -->
                <div class="inner flexLayout" v-if="layout === 'verticalImageTextLayout'">

                    <div class="imageArea" style="width: 120px;">
                        <img class="cover fullSpace" :src="dataItem.coverImg"/>
                    </div>
                    <div style="overflow:hidden;" class="flexItem paddingL8">
                        <div style="white-space: nowrap;" class="titleArea f14 color333 fWeight500">
                            {{dataItem.title}}
                        </div>
                        <div style="margin-top:4px;color: #717380;" class="descArea f12 fWeight400"
                             v-show="dataItem.liveCount > 0">
                            共{{dataItem.liveCount}}节课
                        </div>
                        <div class="clearfix">
                            <div class="priceArea floatL">
                                <strong class="red">￥{{dataItem.price}}</strong>
                                <span class="textDelete color999" style="font-size: 12px; margin-left: 8px;">
                                            ￥{{dataItem.marketPrice}}
                                        </span>
                            </div>
                            <div class="learningArea fr f12 color999" style="padding-top: 4px;">
                                {{dataItem.applicantCount}}人在学
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 水平3卡片布局 -->
                <div class="inner" v-if="layout === 'table2ColumnCardLayout'">
                    <div class="imageArea marginB8 roundBorder8">
                        <img class="cover fullSpace" :src="dataItem.coverImg"/>
                    </div>
                    <div class="titleArea f15 color333 bold marginB8 textOverflowShowEllipsis">
                        {{dataItem.title}}
                    </div>
                    <div class="descArea f12">
                        共{{dataItem.applicantCount}}人学
                    </div>
                </div>

            </div>

            <!-- 暂时搜不到内容，搜搜其他内容吧 -->
            <div class="alignC paddingT20 font14r" v-show="dataList.length < 1">
                <img src="notice/notice_no_search_result.png" width="282"/><br/>
                暂时搜不到内容，可
                <span class="blue" @click="contact()">联系师讯客服</span>
                搜索更多内容
            </div>

            <div class="font12r grey60 alignCenter" style="padding: 26px 0 9px;"
                 v-show="status=='ready' && pagination.current == pagination.totalPage"
                 :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                -没有更多啦-
            </div>

        </div>
    </div>
</template>
<script>

import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// style
import '@comp/vodCourse/course.scss';

// data
import bizTypeEnum from '@data/bizTypeEnum';
import externalApp from '@data/externalApp';

// util
import appHelper from '@util/appHelper';

const config = {
    apiConfig : {
        list : {
            url : 'portal/v4/index/search',
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages',
            params : {
                bizType : bizTypeEnum.VOD.code
            }
        }
    }
};

export default {
    name: "courseList",
    extends : shixunPagePart,
    props : {
        layout : {
            type : String,
            default : 'verticalImageTextLayout'
        }
    },
    data () {
        return {
            apiConfig: config.apiConfig,
            enableDataList : true,
            scrollToLoadNextPage : true
        }
    },
    methods : {
        viewItem(dataItem) {
            let url = '/learn/course/' + dataItem.id;
            appHelper.redirect(url);
        },
        contact() {
            appHelper.redirect(externalApp.oldShixun.baseUrl + 'html/me/contact.html');
        }
    }
};
</script>

<style lang="scss" scope>

</style>
